import { render, staticRenderFns } from "./VegeIssueFilterComponent.vue?vue&type=template&id=0a47be7b"
import script from "./VegeIssueFilterComponent.vue?vue&type=script&lang=ts"
export * from "./VegeIssueFilterComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports